/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import DefaultOption from '../../components/defaultOption';
import s from './index.module.scss';
import multiOption from '../styles/multiOption.module.scss';
import common from '../index.module.scss';
import optionsImages from '../../survey/optionsImages';
import optionsImagesMan from '../../surveyMan/optionsImagesMan';
import questionsMethods from '../../survey/questions';
import RecommendTimesWeek from '../../components/recommendTimesWeek';

function DefaultQuestion(props) {
	const { T } = useT();
	const { options, name } = props.step;
	const { optionsImagesType, planMan } = props;
	const currentStep = useSelector((state) => state.steps.currentStep);
	const gender = questionsMethods.getAnswers({ questionName: 'gender' }).value;

	const isExpandedDesign = props.isExpandedDesign ? multiOption.designExpanded : '';
	const isExpandedDesignImg = props.isExpandedDesign ? multiOption.expandedImg : '';
	const isSquareDesignStyle = props.isSquareDesignStyle ? multiOption.squareStyle : '';
	const isSquareDesignStyleImg = props.isSquareDesignStyle ? multiOption.squareStyleImg : '';
	const isExpandedDesignStyle = isExpandedDesign && isExpandedDesignImg ? multiOption.withImg : '';
	const isLargeImgDesignStyle = props.isLargeImgDesign ? multiOption.option_planMan : '';
	const isIconDesignStyleBig = props.isLargeImgDesign ? multiOption.icon_planMan_big : '';
	const isIconDesignStyleSmall = !props.isLargeImgDesign ? multiOption.icon_planMan_small : '';
	const isIconDesignStyleNoneGrey = props.isLargeImgDesign ? multiOption.icon_nonGrey : '';

	return (
		<section className={common.step}>
			<div className={classNames(isSquareDesignStyle ? multiOption.bigTitle : common.stepTitle)}>{T(name)}</div>
			<div className={common.stepDescription}>{T(`${name}_description`)}</div>
			<div className={classNames(isSquareDesignStyle ? multiOption.squareDesign : s.options)}>
				{
					options && Object.entries(options).map((option) => {
						let imgSrc;
						if (optionsImagesType[name]) imgSrc = (gender && gender !== 'female' && optionsImagesType[name][gender]) ? optionsImagesType[name][gender][option[1].value] : optionsImagesType[name][option[1].value];
						const withDescription = option[1].description;

						return (
							<DefaultOption
								key={option[1].value}
								className={
									classNames(
										isSquareDesignStyle ? multiOption.squareStyle : multiOption.option,
										isLargeImgDesignStyle,
										isExpandedDesign,
										isExpandedDesignStyle,
									)
								}
								selectedStateClass={isSquareDesignStyle ? multiOption.optionSelectedSquare : multiOption.optionSelected}
								option={option[1]}
								questionName={name}
								disableFromFocus={!props.isThisCurrentStep}
								resetIfValueSelected={props.resetIfValueSelected}
							>
								{imgSrc && (
									<img
										className={
											classNames(
												multiOption.icon,
												planMan && isIconDesignStyleBig,
												planMan && isIconDesignStyleSmall,
												isIconDesignStyleNoneGrey,
												isExpandedDesignImg,
												isSquareDesignStyleImg
											)
										}
										src={imgSrc}
										alt="img"
									/>
								)}
								{!withDescription && <span className={isSquareDesignStyle && multiOption.squareStyleText}>
									{T(`${name}_${option[1].value}`)}
								</span>}
								{withDescription &&
									(
										<div>
											<div className={classNames(option[1].design === 'smallTitleWithDescription' ? '' : s.title)}>{T(`${name}_${option[1].value}`)}</div>
											<div className={s.description}>{T(`${name}_${option[1].description}`)}</div>
										</div>
									)}
								{!isSquareDesignStyle && <div className={multiOption.checkbox} />}
							</DefaultOption>
						);
					})
				}
			</div>
			{currentStep === 'choose_days' && planMan && <RecommendTimesWeek />}
		</section>
	);
}

export function MultiOptions(props) {
	const { isThisCurrentStep, isCurrentStepCompleted, resetIfValueSelected } = props;
	const planMan = useSelector((state) => state.global.planMan);
	const questions = useSelector((state) => state.questions.list);
	const questionName = props.stepData.name;
	const question = questions[questionName];
	const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
	const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
	const optionsImagesType = planMan ? optionsImagesMan : optionsImages;

	return (
		<div className={classNames(s.step, isThisCurrentStepClass, isThisStepCompletedClass)}>
			<DefaultQuestion
				step={question}
				index={1}
				isThisCurrentStep={isThisCurrentStep}
				isExpandedDesign={props.designExpanded}
				isLargeImgDesign={props.largeImgDesign}
				isSquareDesignStyle={props.squareStyle}
				resetIfValueSelected={resetIfValueSelected}
				planMan={planMan}
				optionsImagesType={optionsImagesType}
			/>
		</div>
	);
}
